"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookieParserDE = void 0;
class CookieParserDE {
  static mapCookie(address) {
    return {
      addressId: address.id,
      city: address.name,
      street: address.streetName,
      housenumber: address.streetNr,
      zipcode: address.postcode,
      district: address.district,
      region: address.region
    };
  }
}
exports.CookieParserDE = CookieParserDE;